import axios from "axios";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

// In development (localhost), keep requests relative to the CRA dev server
// proxy at /api which forwards to:
//   - http://187.77.136.60:8020/api
// In any deployed/non-local environment, hit the production EnViz API directly.
const PROD_API_BASE =
  window.__ENVVIZ_API_BASE ||
  process.env.REACT_APP_API_URL ||
  "http://187.77.136.60:8020/api";

const baseURL = isLocal ? "/api" : PROD_API_BASE;

const api = axios.create({
  baseURL,
  timeout: 60000, // Increased to 60 seconds for second-wise data fetching
});

export const getApiBase = () => baseURL;

// If a request through the local CRA proxy returns 404 or a network error,
// some dev setups have issues with proxying. In that case, retry the request
// directly against the production API base (PROD_API_BASE). We only do this
// for requests that were originally targeted at the relative '/api' base.
// In-browser fallback retries to the production API are disabled because
// direct cross-origin attempts will be blocked by CORS when the backend
// doesn't allow the browser origin. If the CRA dev proxy fails (404),
// it's almost always a local proxy/config issue and should be fixed by
// restarting the dev server or adjusting `src/setupProxy.js`.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    try {
      const config = error.config || {};
      const status = error?.response?.status;

      // Only treat as a potential proxy issue if there's no response (network error)
      // or a 404 from the dev proxy. Auth errors like 401 should be handled by the app.
      if (
        config &&
        config.baseURL === "/api" &&
        (!status || status === 404)
      ) {
        // Provide a friendly, actionable console hint for developers
        console.error(
          "Dev proxy error: request to '/api' failed.",
          "If you're running locally, restart the dev server and check src/setupProxy.js and terminal logs.",
          {
            status,
            url: config.url,
            message: error.message,
          }
        );
      }
    } catch (e) {
      // ignore
    }
    return Promise.reject(error);
  },
);

// Add a helper to debug what's happening in production
api.interceptors.request.use((config) => {
  if (!isLocal) {
    console.log(
      `[API Request] ${config.method.toUpperCase()} ${config.baseURL}${config.url
      }`
    );
  }
  return config;
});

export default api;
